import { CSS_CLASSES } from './constants';

interface PlaceholderImageProps {
  src: string;
  variant?: 'blurred' | 'normal' | 'content';
}

export const PlaceholderImage = ({
  src,
  variant = 'blurred',
}: PlaceholderImageProps) => (
  <img
    src={src}
    alt=""
    className={CSS_CLASSES.placeholder[variant]}
    aria-hidden="true"
  />
);

interface MainImageProps {
  src: string;
  srcSet: string;
  alt: string;
  priority: boolean;
  imgRef: React.RefObject<HTMLImageElement>;
  onLoad: () => void;
  onError: () => void;
  variant?: 'blurred' | 'normal' | 'content';
}

export const MainImage = ({
  src,
  srcSet,
  alt,
  priority,
  imgRef,
  onLoad,
  onError,
  variant = 'blurred',
}: MainImageProps) => (
  <img
    ref={imgRef}
    src={src}
    srcSet={srcSet}
    sizes={
      variant === 'content'
        ? '(max-width: 640px) 100vw, (max-width: 960px) 90vw, (max-width: 1024px) 85vw, (max-width: 1920px) 70vw, 60vw'
        : '100vw'
    }
    alt={alt}
    aria-hidden={variant !== 'content'}
    className={CSS_CLASSES.mainImage[variant]}
    loading={priority ? 'eager' : 'lazy'}
    onLoad={onLoad}
    onError={onError}
    {...{ fetchpriority: priority ? ('high' as const) : ('low' as const) }}
  />
);
